export const jumpLinkDataAttribute = 'data-jump-link-label';

export const getJumpLinkSelectorById = (label: string) =>
  `[${jumpLinkDataAttribute}="${CSS.escape(label)}"]`;

export type JumpLinkData = {
  label: string;
  element: HTMLElement;
};

export const getAllJumpLinks = (): Array<JumpLinkData> => {
  const selections = document.querySelectorAll<HTMLElement>(`[${jumpLinkDataAttribute}]`);

  const jumpLinkElements = Array.from(selections)
    .filter((element) => Boolean(element.getAttribute(jumpLinkDataAttribute)))
    .map((element) => ({ label: element.getAttribute(jumpLinkDataAttribute) || '', element }));

  return jumpLinkElements;
};

export const getActiveJumpLink = () => {
  const jumpLinks = getAllJumpLinks();
  const scrollPosition = window.scrollY;

  let activeLink: JumpLinkData | null = null;

  for (const jumpLink of jumpLinks) {
    const elementTop = jumpLink.element.getBoundingClientRect().top + scrollPosition;
    const computedStyles = getComputedStyle(jumpLink.element);
    const offset = parseInt(computedStyles.scrollMarginTop, 10) || 150;

    if (scrollPosition >= elementTop - offset - 10) {
      activeLink = jumpLink;
    } else {
      break;
    }
  }

  return activeLink || jumpLinks[0] || null;
};

export const setJumpLinkAttributes = (jumpLinkLabel?: string) => {
  return jumpLinkLabel
    ? {
        [jumpLinkDataAttribute]: jumpLinkLabel,
      }
    : {};
};
